import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: '100 Hooks Que Generan Ventas',
  description: 'Una biblioteca lista para copiar con hooks diseñados para captar atención, generar curiosidad y aumentar el interés de compra. Ideal para reels, anuncios, publicaciones, TikToks y contenido orgánico.'
}, {
  title: 'Swipe Files de Anuncios',
  description: 'Ejemplos de anuncios listos para adaptar a tu negocio. Incluye estructuras tipo UGC, emocionales, agresivos, de problema/solución y pensados para Meta Ads.'
}, {
  title: 'Prompts de IA Para Marketing',
  description: 'Una biblioteca de prompts listos para copiar y pegar en ChatGPT. Creá hooks, copies, anuncios, ideas de contenido, CTAs, reels y ofertas en minutos.'
}, {
  title: 'Plantillas de Reels',
  description: 'Plantillas listas para grabar reels con estructura clara: Hook, Escena por escena, Texto en pantalla, Idea visual, CTA final. Para crear contenido más rápido.'
}, {
  title: '50 CTA Que Convierten',
  description: 'Llamados a la acción listos para usar en publicaciones, reels, historias, anuncios y mensajes. Diseñados para generar comentarios, clics, DMs y ventas.'
}];
export const Bonuses = () => {
  return <section className="py-12 md:py-24 bg-brand-dark" data-id="element-24">
      <div className="container px-4 mx-auto max-w-6xl" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-10 md:mb-16 text-center" data-id="element-26">
          <div className="inline-flex items-center gap-2 px-4 py-2 mb-4 md:mb-6 text-xs md:text-sm font-bold tracking-widest uppercase border rounded-full text-brand-gold border-brand-gold/30 bg-brand-gold/10" data-id="element-27">
            Gratis por el día de hoy
          </div>
          <h2 className="text-3xl font-bold md:text-5xl" data-id="element-28">
            Bonos <span className="text-gradient-gold" data-id="element-29">Exclusivos</span>
          </h2>
        </motion.div>

        <div className="grid gap-4 md:gap-6 md:grid-cols-2 lg:grid-cols-3 mb-10 md:mb-16" data-id="element-30">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-6 md:p-8 border bg-brand-card rounded-2xl border-brand-gold/20 relative overflow-hidden" data-id="element-31">
              <div className="absolute top-0 left-0 w-full h-1 bg-gold-gradient" data-id="element-32" />
              <Gift className="w-7 h-7 md:w-8 md:h-8 mb-3 md:mb-4 text-brand-gold" data-id="element-33" />
              <h3 className="mb-2 md:mb-3 text-lg md:text-xl font-bold text-white" data-id="element-34">
                Bono {index + 1} — {bonus.title}
              </h3>
              <p className="text-gray-400 leading-relaxed text-sm" data-id="element-35">
                {bonus.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto p-6 md:p-8 text-center border-2 rounded-2xl border-brand-gold bg-brand-gold/5" data-id="element-36">
          <p className="text-base md:text-xl text-gray-300 mb-2" data-id="element-37">
            Valor total de los 5 bonos:{' '}
            <span className="line-through text-gray-500" data-id="element-38">$65.000 ARS</span>
          </p>
          <p className="text-2xl md:text-3xl font-bold text-white mb-4 md:mb-6" data-id="element-39">
            Por el día de hoy →{' '}
            <span className="text-brand-gold" data-id="element-40">GRATIS ✅</span>
          </p>
          <div className="flex justify-center" data-id="element-41">
            <a href="#pricing" className="text-brand-gold hover:text-brand-gold-light font-bold underline underline-offset-4 transition-colors" data-id="element-42">
              Reclamar mis bonos ahora
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
};